import SortableJs from 'sortablejs'
import { selectors } from './selector'
import { constant } from './constant'

const { selector } = constant

export const Sortable = (() => {
	const initTargets = () => {
		const targets = selectors.getTargets()
		for (let i = 0, { length } = targets; i < length; i++) {
			const target = targets[i]
			if (!target) continue

			initSortable(target)
		}
	}

	const initSortable = (el: HTMLElement) =>
		SortableJs.create(el, {
			onUpdate: (e) => {
				const scope = e.target
				const handler = scope.getAttribute(selector.handler)
				const rows = selectors.getRows(scope)
				if (!rows) return

				const data: any[] = []
				for (let i = 0, { length } = rows; i < length; i++) {
					const row = rows[i]
					if (!row) continue
					data.push(row.getAttribute(selector.rowId))
				}

				// @ts-ignore
				$.nette.ajax({
					method: 'post',
					dataType: 'json',
					url: handler,
					data: { data },
				})
			},
		})

	const init = () => {
		initTargets()
	}

	return {
		init,
	}
})()
